import type { Product } from "../schema/Product.js";

export function getUniqueProductCategories(products: Product[]): string[] {
	return [...new Set(products.map((product) => product.parentProductCategory).filter(Boolean))] as string[];
}
